
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Europa Component Library`}</h1>
    <p>{`The Europa Component Library (ECL) is a comprehensive style guide containing the design elements and visual standards that make up all Europa websites and applications.`}</p>
    <p>{`The name Europa Family covers all digital content managed by the European Commission, and contains`}</p>
    <ul>
      <li parentName="ul">{`European Commission websites hosted under the ec.europa.eu domain`}</li>
      <li parentName="ul">{`European Union websites hosted under the europa.eu domain`}</li>
    </ul>
    <p>{`To get started in building your own digital content using the ECL, please chose one of the component libraries below.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;